import {
  isSaferpayPaymentPage,
  BE_CREDIT_CARD,
  BE_BANK_TRANSFER,
  BE_MONRI,
  BE_STRIPE,
  BE_M2PAY,
  BE_WSPAY,
  BE_SAFERPAY
} from 'Rentlio/utils/paymentTypesEnum'
import { validateData } from 'Rentlio/helper/validator'
import { cardNumberConstraint } from 'Rentlio/helper/validator/cardNumber'
import { cardCvvNumberConstraint } from 'Rentlio/helper/validator/cardCvv'
import { emailConstraint } from 'Rentlio/helper/validator/email'
import { expirationDateConstraint } from 'Rentlio/helper/validator/expirationDate'
import { maxLengthConstraint } from 'Rentlio/helper/validator/maxLength'
import { notEmptyConstraint } from 'Rentlio/helper/validator/notEmpty'
import { termsOfServiceAcceptedConstraint } from 'Rentlio/helper/validator/termsOfServiceAccepted'

export const getPaymentDetails = (
  selectedPaymentMethod,
  cardholderSameAsGuest,
  firstName,
  lastName,
  cardholderName,
  expirationDate,
  cvv,
  cardNumber
) => {
  // If Bank Transfer is selected add only payment method type
  if (selectedPaymentMethod === BE_BANK_TRANSFER) {
    return { type: selectedPaymentMethod }
  }
  if (selectedPaymentMethod === BE_CREDIT_CARD) {
    return {
      name: cardholderSameAsGuest ? firstName + ' ' + lastName : cardholderName,
      expirationDate,
      cvv,
      cardNumber,
      type: selectedPaymentMethod
    }
  }
  // monri/stripe/m2pay components are checking for errors in monri/stripe/m2pay inputs
  if (
    selectedPaymentMethod === BE_MONRI ||
    selectedPaymentMethod === BE_STRIPE ||
    selectedPaymentMethod === BE_M2PAY ||
    selectedPaymentMethod === BE_WSPAY
  ) {
    return {
      name: cardholderSameAsGuest ? firstName + ' ' + lastName : cardholderName,
      type: selectedPaymentMethod
    }
  }
}

export const getBookErrors = (selectedPaymentMethod, guestDetails, paymentDetails, termsAccepted) => {
  if (selectedPaymentMethod === BE_BANK_TRANSFER) {
    return validateData(
      { ...guestDetails, ...paymentDetails, termsAccepted },
      {
        firstName: [notEmptyConstraint, val => maxLengthConstraint(val, 20)],
        lastName: [notEmptyConstraint, val => maxLengthConstraint(val, 20)],
        email: [notEmptyConstraint, val => maxLengthConstraint(val, 150), emailConstraint],
        phone: [notEmptyConstraint, val => maxLengthConstraint(val, 45)],
        country: [notEmptyConstraint],
        estimatedTimeOfArrival: [notEmptyConstraint],
        termsAccepted: [termsOfServiceAcceptedConstraint]
      }
    )
  }
  if (selectedPaymentMethod === BE_CREDIT_CARD) {
    return validateData(
      { ...guestDetails, ...paymentDetails, termsAccepted },
      {
        firstName: [notEmptyConstraint, val => maxLengthConstraint(val, 20)],
        lastName: [notEmptyConstraint, val => maxLengthConstraint(val, 20)],
        email: [notEmptyConstraint, val => maxLengthConstraint(val, 150), emailConstraint],
        phone: [notEmptyConstraint, val => maxLengthConstraint(val, 45)],
        country: [notEmptyConstraint],
        estimatedTimeOfArrival: [notEmptyConstraint],
        name: [notEmptyConstraint],
        expirationDate: [notEmptyConstraint, expirationDateConstraint],
        cvv: [cardCvvNumberConstraint],
        cardNumber: [notEmptyConstraint, cardNumberConstraint],
        termsAccepted: [termsOfServiceAcceptedConstraint]
      }
    )
  }
  // monri/stripe/m2pay components are checking for errors in monri/stripe/m2pay inputs
  if (
    selectedPaymentMethod === BE_MONRI ||
    selectedPaymentMethod === BE_STRIPE ||
    selectedPaymentMethod === BE_M2PAY ||
    selectedPaymentMethod === BE_WSPAY
  ) {
    return validateData(
      { ...guestDetails, ...paymentDetails, termsAccepted },
      {
        firstName: [notEmptyConstraint, val => maxLengthConstraint(val, 20)],
        lastName: [notEmptyConstraint, val => maxLengthConstraint(val, 20)],
        email: [notEmptyConstraint, val => maxLengthConstraint(val, 150), emailConstraint],
        phone: [notEmptyConstraint, val => maxLengthConstraint(val, 45)],
        country: [notEmptyConstraint],
        address: [notEmptyConstraint, val => maxLengthConstraint(val, 100)],
        city: [notEmptyConstraint, val => maxLengthConstraint(val, 30)],
        postalCode: [notEmptyConstraint, val => maxLengthConstraint(val, 9)],
        estimatedTimeOfArrival: [notEmptyConstraint],
        name: [notEmptyConstraint],
        termsAccepted: [termsOfServiceAcceptedConstraint]
      }
    )
  }
  if (selectedPaymentMethod === BE_SAFERPAY || isSaferpayPaymentPage(selectedPaymentMethod)) {
    return validateData(
      { ...guestDetails, ...paymentDetails, termsAccepted },
      {
        firstName: [notEmptyConstraint, val => maxLengthConstraint(val, 20)],
        lastName: [notEmptyConstraint, val => maxLengthConstraint(val, 20)],
        email: [notEmptyConstraint, val => maxLengthConstraint(val, 150), emailConstraint],
        phone: [notEmptyConstraint, val => maxLengthConstraint(val, 45)],
        country: [notEmptyConstraint],
        estimatedTimeOfArrival: [notEmptyConstraint],
        termsAccepted: [termsOfServiceAcceptedConstraint]
      }
    )
  }
}

export const getRentlioPayPaymentDetails = (selectedPaymentMethod, scheduledPayments, currency, token, publicId) => {
  if (selectedPaymentMethod === BE_SAFERPAY) {
    return {
      type: selectedPaymentMethod,
      currency,
      scheduledPayments,
      publicId
    }
  }
  if (isSaferpayPaymentPage(selectedPaymentMethod)) {
    return {
      type: BE_SAFERPAY,
      aliasToken: token,
      isPaymentPage: true,
      currency,
      scheduledPayments,
      publicId
    }
  }
}
